import { scan } from 'react-scan'

import env from '@core/env'

window.global ||= window

scan({ enabled: ['local', 'dev'].includes(env.ENV as string) })
